<template>
    <div class="container" :class="{ 'text-center' : page === 'main' }">
        <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-12 pb-4">
                <h1 style=" font-weight: bold;">Frequently Asked Questions</h1>
            </div>
        </div>
        <div class="accordion" id="faqAccordion">
            <div v-for="(q, key) in data" class="pb-3">
                <div :id="'heading' + key" class="collapsed" data-toggle="collapse" :data-target="'#collapse' + key"
                     aria-expanded="false" :aria-controls="'collapse' + key">
                    <h5 class="mb-0">
                        <span class="font-weight-bold text-dark">{{ q.plQuestion }}</span>
                        <i class="las la-angle-down"></i>
                    </h5>
                </div>

                <div :id="'collapse' + key" class="collapse" :aria-labelledby="'heading' + key"
                     data-parent="#faqAccordion">
                    <div class="card-body ml-0 pl-0 col-lg-8 col-12" :class="{ 'mx-auto' : page === 'main' }" v-html="q.plAnswer">
                    </div>
                </div>

                <hr class="col-5" :class="{ 'ml-0' : page === 'dashboard' }">
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "faq",
        props: {
            page: String,
            data: Array
        }
    }
</script>

<style scoped>

</style>
